import { render, staticRenderFns } from "./sup-deposit-mtpay.vue?vue&type=template&id=7f439d15"
import script from "./sup-deposit-mtpay.vue?vue&type=script&lang=js"
export * from "./sup-deposit-mtpay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports